<app-iff-shipment-summary
  [title]="'FRT Shipment Reports Master List'"
  [IFFShipmentPaginationResults$]="FRTShipmentPaginationResults$"
  [isFRTShipment]="true"
  [updateIFFShipmentDetailRequestFn]= "updateFRTIffShipmentDetailRequestFn" 
  [IFFShipmentDetailsColumnDefs]= "getFRTIffShipmentDetailsColumnDefs()"
  [IFFShipmentDetailResults$]="frtIFFShipmentDetailResults$"
  (delinquencyReportSelected)="OnDelinquencyReportSelected()"
  (comprehensiveReportSelected)="OnFrtComprehensiveReportSelected()"
></app-iff-shipment-summary>
